import { render, staticRenderFns } from "./ActivatePersonal.vue?vue&type=template&id=f119f300&scoped=true"
import script from "./ActivatePersonal.vue?vue&type=script&lang=js"
export * from "./ActivatePersonal.vue?vue&type=script&lang=js"
import style0 from "./ActivatePersonal.vue?vue&type=style&index=0&id=f119f300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f119f300",
  null
  
)

export default component.exports